"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var campaign_1 = require("../../campaign");

var campaignValues = [];

exports.subscribeToCampaign = function (callback, campaignId) {
  campaign_1.setHandler(campaignId, callback);
  findCampaignValue(campaignId, callback, campaign_1.sendInitialValue);
};

var findCampaignValue = function findCampaignValue(campaignId, callback, sendInitialValue) {
  if (campaignValues[campaignId]) {
    sendInitialValue(campaignId, campaignValues[campaignId], callback);
  }

  var interval = setInterval(function () {
    var campaignDefaultVal = getCookie("_vis_opt_exp_" + campaignId + "_combi");
    var campaignDebugVal = getCookie("debug_vis_opt_exp_" + campaignId + "_combi");
    var campaignVal = campaignDefaultVal || campaignDebugVal;

    if (campaignVal) {
      clearInterval(interval);
      var vwoVariant = parseInt(campaignVal) - 1;
      campaignValues[campaignId] = vwoVariant;
      sendInitialValue(campaignId, vwoVariant, callback);
    }
  }, 200);
};

var getCookie = function getCookie(name) {
  var value = "; " + document.cookie;
  var parts = value.split("; " + name + "=");
  if (parts.length == 2) return parts.pop().split(";").shift();
};

void function register() {
  /* react-hot-loader/webpack */
  var reactHotLoader = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal["default"] : undefined;

  if (!reactHotLoader) {
    return;
  }
  /* eslint-disable camelcase, no-undef */


  var webpackExports = typeof __webpack_exports__ !== 'undefined' ? __webpack_exports__ : exports;
  /* eslint-enable camelcase, no-undef */

  if (!webpackExports) {
    return;
  }

  if (typeof webpackExports === 'function') {
    reactHotLoader.register(webpackExports, 'module.exports', "/opt/atlassian/pipelines/agent/build/node_modules/react-controlled-ab/datalayers/vwo/index.js");
    return;
  }
  /* eslint-disable no-restricted-syntax */


  for (var key in webpackExports) {
    /* eslint-enable no-restricted-syntax */
    if (!Object.prototype.hasOwnProperty.call(webpackExports, key)) {
      continue;
    }

    var namedExport = void 0;

    try {
      namedExport = webpackExports[key];
    } catch (err) {
      continue;
    }

    reactHotLoader.register(namedExport, key, "/opt/atlassian/pipelines/agent/build/node_modules/react-controlled-ab/datalayers/vwo/index.js");
  }
}();